import React, { useMemo } from 'react';
import MuiMenuItem from '@material-ui/core/MenuItem/MenuItem';
import clsx from 'classnames';

import { useNotificationsListItemStyles as useStyles } from './notifications-styles';
import { parseHtmlMessage, parseDate } from './notifications-utils';
import { Notification } from 'types';

export const NotificationsListItem = ({
  notification,
  readNotifications,
  style,
  ref,
}: {
  notification: Notification;
  readNotifications?: (ids: string[]) => Promise<boolean>;
  style?: React.CSSProperties;
  ref?: React.RefObject<HTMLLIElement>;
}) => {
  const cls = useStyles();

  const { id, content: contentRaw, created: createdRaw, read } = notification;

  const created = useMemo(() => parseDate(createdRaw), [createdRaw]);
  const content = useMemo(() => parseHtmlMessage(contentRaw, cls), [
    contentRaw,
    cls,
  ]);

  return (
    <MuiMenuItem
      disableRipple
      disableTouchRipple
      classes={{ root: cls.root }}
      style={style}
      ref={ref}
    >
      <div className={cls.body}>
        <div className={cls.contentWrapper}>
          <div
            className={clsx(cls.content, {
              [cls.unreadContent]: !read,
            })}
          >
            {content}
          </div>
          {!read && <div className={cls.unreadIndicator} />}
        </div>
        <div className={cls.info}>
          <div className={cls.infoCreated}>{created}</div>
          {!!readNotifications && !read && (
            <div
              className={cls.infoRead}
              onClick={() => readNotifications([id])}
            >
              Přečteno
            </div>
          )}
        </div>
      </div>
    </MuiMenuItem>
  );
};
